module.exports = __webpack_public_path__ + "img/high-school-custom-service.c36a066a.png";